import { ActionType } from '../../constants/ActionTypes'

export default function securityReducer(state = {}, action = {}) {
    switch (action.type) {
        case ActionType.SWITCH_AUTH_BEGIN:
            return {
                ...state,
                switchAuthLoading: true,
                error: false
            }

        case ActionType.SWITCH_AUTH_ERROR:
        case ActionType.SWITCH_AUTH_SUCCESS:

            return {
                ...state,
                switchAuthLoading: false,
            }

        case ActionType.GET_SECURITY_CODE_BEGIN:
            return {
                ...state,
                isCodeLoading: true,
                codeData: {}
            }

        case ActionType.GET_SECURITY_CODE_ERROR:
            return {
                ...state,
                isCodeLoading: false,
                codeData: {}
            }
        case ActionType.GET_SECURITY_CODE_SUCCESS:

            return {
                ...state,
                isCodeLoading: false,
                codeData: action.payload
            }
        case "GET_REGISTERED_PASSKEYS":
            return {
                ...state,
                passkeys: action.payload
            }
        default:
            return state;
    }

}

